import { useTypedSelector } from "../../../store/store";
import CustomLink from "../../shared/CustomLink";
import SvgIcon from "../../shared/SvgIcon";
import { type InternalIconTypes } from "../../shared/SvgIcon";

import styles from "./index.module.scss";

interface ILogoProps {
  pathname?: string;
  internalLogoIconType?: InternalIconTypes;
}

interface ILogoContainerProps {
  pathname?: string;
  className: string;
}

function LogoContainer({
  pathname,
  className,
  children,
}: React.PropsWithChildren<ILogoContainerProps>) {
  if (pathname) {
    return (
      <CustomLink to={pathname} className={className}>
        {children}
      </CustomLink>
    );
  }

  return <div className={className}>{children}</div>;
}

function Logo({ pathname, internalLogoIconType }: ILogoProps) {
  const { logo_url } = useTypedSelector((state) => state.environment);

  if (!logo_url) {
    return null;
  }

  return (
    <LogoContainer className={styles.container} pathname={pathname}>
      {internalLogoIconType ? (
        <SvgIcon internalType={internalLogoIconType} />
      ) : (
        <img src={logo_url} className={styles.logo} alt="logo" />
      )}
    </LogoContainer>
  );
}

export default Logo;
